define('inherit', [], function () {
	/**
	 * Создание «родительского» метода
	 * @param   {*}  fn
	 * @param   {*} parent
	 * @returns {*}
	 * @private
	 */
	function _parentize(fn, parent) {
		if (typeof fn === 'function') {
			fn.parent = parent;
		}
		return	fn;
	}


	/**
	 * Примитивное наследование
	 * @param   {Function|Object}  Class
	 * @param   {Object}    [methods]
	 * @returns {Function}
	 * @private
	 */
	function inherit(Class, methods) {
		if (arguments.length === 1) {
			methods = Class;

			Class = methods.constructor;
			Class.fn = Class.prototype = methods;

			return inherit.apply(Class);
		}


		var key,
			ClassExt = _parentize(methods.hasOwnProperty('constructor') ? methods.constructor : function (a, b, c) {
				var retVal;

				switch (arguments.length) {
					case 1: retVal = Class.call(this, a); break;
					case 2: retVal = Class.call(this, a, b); break;
					case 3: retVal = Class.call(this, a, b, c); break;
					default: retVal = Class.apply(this, arguments); break;
				}

				if (retVal !== void 0) {
					return retVal;
				}
			}, Class)
		;


		// Наследуем статические методы и свойства
		for (key in Class) {
			if (Class.hasOwnProperty(key)) {
				ClassExt[key] = Class[key];
			}
		}


		// Наследуем
		ClassExt.prototype = (function () {
			var F = function () {};
			F.prototype = Class.fn;
			return new F;
		})();


		// Быстрый доступ к прототипу
		ClassExt.fn = ClassExt.prototype;


		// Методы класса
		for (key in methods) {
			ClassExt.fn[key] = _parentize(methods[key], ClassExt.fn[key]);
		}


		// Выправляем конструктор
		ClassExt.fn.constructor = ClassExt;


		return inherit.apply(ClassExt);
	}


	/**
	 * Подмешать методы
	 * @param   {Function}  target
	 * @returns {Function}
	 */
	inherit.apply = function (target) {
		target.extend = target.extend || function (methods) {
			return inherit(this, methods);
		};
		return target;
	};


	// Export
	return inherit;
});
